export default __webpack_public_path__ + "static/media/ic-announcement.62ca8017.svg";